import React from 'react'
import {Context as StoreContext} from '../../contexts/Store'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import config from '../../config.json'


const StoreForm = ({open, close, model, submit, ...rest}) => {
    const { recall, setRecall } = React.useContext(StoreContext)
    const action = model?"Editar":"Añadir" 
    const title = `${action} Tienda`
    return (
        <Dialog onClose={close} open={open}>
            <DialogTitle>{title}</DialogTitle>
            <ObjectForm ignored={['id']} recall={recall} submit={submit}
                obj={{name:'', reputation: '', color:'' }}
                labels={{name:'Nombre', reputation: 'Reputacion', color:'Color' }}
                types={{name:'text', reputation: 'select', color:'color'  }}
                options={{reputation:config.availableReputations}}
                controlled={{color: model?model.color:'#000000'}}
                changed={model || {}}
            />
            <Button onClick={() => {setRecall(true);close()}}>{action}</Button>
        </Dialog>
    )
}
export default StoreForm